import $ from 'jquery'
import 'select2'

window.initMultipleSelect = function() {
  $(".multiselect").select2();
}
